export default {
    listMailDraft: state => state.listMailDraft,
    getSearchFilter: state => state.searchFilter,
    preMailDraft: state => state.preMailDraft,
    mode: state => state.mode,
}